(function () {
  'use strict';

  var KLAVIYO_COMPANY_ID = 'XxX2Ht';
  var KLAVIYO_API_REVISION = '2024-10-15';
  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID;

  var modal = document.getElementById('BISModal');
  var form = document.getElementById('BISForm');
  var emailInput = document.getElementById('BISEmail');
  var emailError = document.getElementById('BISEmailError');
  var variantIdInput = document.getElementById('BISVariantId');
  var variantInfoEl = document.getElementById('BISVariantInfo');
  var productImageEl = document.getElementById('BISProductImage');
  var productImageSuccessEl = document.getElementById('BISProductImageSuccess');
  var submitText = document.getElementById('BISSubmitText');
  var submitSpinner = document.getElementById('BISSubmitSpinner');
  var successEl = document.getElementById('BISSuccess');
  var formContent = document.getElementById('BISModalContent');

  function openBISModal(variantId, productTitle, variantInfo, productImage) {
    variantIdInput.value = variantId;

    // Build heading prefix: "Size 7" or just the product title
    var headingPrefix = variantInfo ? 'Size ' + variantInfo : productTitle;
    variantInfoEl.textContent = headingPrefix || '';

    // Set product image
    var imgSrc = productImage || '';
    productImageEl.src = imgSrc;
    productImageEl.alt = productTitle || '';
    productImageSuccessEl.src = imgSrc;
    productImageSuccessEl.alt = productTitle || '';

    emailInput.value = '';
    emailError.textContent = '';
    emailInput.classList.remove('bis-modal__input--error');
    submitText.classList.remove('hidden');
    submitSpinner.classList.add('hidden');
    form.querySelector('.bis-modal__submit').removeAttribute('disabled');
    formContent.classList.remove('hidden');
    successEl.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    emailInput.focus();
  }

  function closeBISModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function subscribeBackInStock(email, variantId) {
    var submitBtn = form.querySelector('.bis-modal__submit');
    submitBtn.setAttribute('disabled', 'disabled');
    submitText.classList.add('hidden');
    submitSpinner.classList.remove('hidden');
    emailError.textContent = '';

    var body = JSON.stringify({
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    });

    fetch(KLAVIYO_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_API_REVISION
      },
      body: body
    })
      .then(function (response) {
        if (response.status === 202 || response.ok) {
          formContent.classList.add('hidden');
          successEl.classList.remove('hidden');
        } else {
          throw new Error('Subscription failed');
        }
      })
      .catch(function () {
        emailError.textContent = 'Something went wrong. Please try again.';
        submitBtn.removeAttribute('disabled');
        submitText.classList.remove('hidden');
        submitSpinner.classList.add('hidden');
      });
  }

  // Form submission
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();

      if (!email) {
        emailError.textContent = 'Please enter your email address.';
        emailInput.classList.add('bis-modal__input--error');
        return;
      }

      if (!validateEmail(email)) {
        emailError.textContent = 'Please enter a valid email address.';
        emailInput.classList.add('bis-modal__input--error');
        return;
      }

      emailInput.classList.remove('bis-modal__input--error');
      subscribeBackInStock(email, variantIdInput.value);
    });
  }

  // Event delegation for BIS triggers
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.klaviyo-bis-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openBISModal(
        trigger.dataset.variantId,
        trigger.dataset.productTitle,
        trigger.dataset.variantInfo,
        trigger.dataset.productImage
      );
    }

    // Close modal
    if (e.target.closest('[data-bis-close]')) {
      closeBISModal();
    }
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeBISModal();
    }
  });

  // Clear error on input
  if (emailInput) {
    emailInput.addEventListener('input', function () {
      emailError.textContent = '';
      emailInput.classList.remove('bis-modal__input--error');
    });
  }

  // Expose for dynamic use by VariantSelects
  window.openBISModal = openBISModal;
  window.closeBISModal = closeBISModal;
})();
